<template>
  <div class="appointment">
    <div class="head">
      <div class="article">
        <div class="avatar">
          <!-- <el-image class="img" :src="info.userPicUrl" fit="cover"></el-image> -->
          <img
            class="img"
            :src="info.userPicUrl"
            alt=""
            style="object-fit: cover"
          />
          <!-- <div class="tip" v-if="info.isRecommend"><span class="txt">{{$t("common.recommend")}}</span></div> -->
        </div>
        <div class="btns">
          <a
            @click="toDetail"
            class="ui-btn blue"
          >{{
            $t('common.teacherinfo')
          }}</a>
        </div>
        <div class="info">
          <p class="name">{{ info.teacherName }}</p>
          <p>
            <!-- <span class="tag" v-if="info.teacherLevel === 1">{{$t("common.Higher")}}</span>
            <span class="tag" v-else>{{$t("common.Standard")}}</span> -->
            <span
              class="tag"
              v-if="info.teacherLevel === 2"
            >{{
              $t('common.Higher')
            }}</span>
            <span
              class="tag"
              v-else-if="info.teacherLevel === 3"
            >{{
              $t('common.Super')
            }}</span>
            <span
              class="tag"
              v-else
            >{{ $t('common.Standard') }}</span>
          </p>
          <p>
            <span class="lab">{{ $t('form.course') }}: </span>
            {{
              !!info.courseName.length > 0
                ? info.courseName.replace(',', ' ,')
                : ''
            }}
            <!-- {{
              !!info.courseName.length > 0
                ? info.courseName.slice(0, info.courseName.length - 1)
                : ''
            }} -->
          </p>
          <p class="price">
            US$ {{ info.coursePrice }}/{{ $t('common.lesson') }}
          </p>
        </div>
      </div>
    </div>
    <div class="title-box">
      <div class="article">
        <a
          class="pre"
          @click="preWeek"
        >{{ $t('weeks.pre') }}</a>
        <a
          class="next"
          @click="nextWeek"
        >{{ $t('weeks.next') }}</a>
        <p class="title">{{ $t('weeks.title') }}</p>
      </div>
    </div>
    <div class="article">
      <div class="pannel">
        <div class="filter">
          <!-- <label class="ui-checkbox checked">上午</label>
          <label class="ui-checkbox checked">下午</label> -->
          <!-- <label class="ui-checkbox">晚上</label> -->
          <!-- <div class="timezone">{{info.timeZone}}</div> -->
        </div>
        <ul class="dates">
          <li
            v-for="i in 7"
            :key="i"
          >
            <div v-if="$t('weeks.today') === dateArr[i - 1].show">
              <p class="date">{{ dateArr[i - 1].show }}</p>
              <p class="week">{{ moment(new Date()).format('DD/MM') }}</p>
            </div>
            <div v-else>
              <p class="date">{{ dateArr[i - 1].week }}</p>
              <p class="week">{{ dateArr[i - 1].show }}</p>
            </div>
          </li>
        </ul>
        <ul
          ref="times"
          class="times"
        >
          <li
            v-for="i in 7"
            :key="i"
          >
            <p
              v-for="(cell, index) in timeArr[i - 1]"
              :key="index"
              @click="order(i - 1, index, timeArr[i - 1])"
              :class="{ disable: cell.state === 1, fulled: cell.state === 2 }"
            >
              {{ cell.time }}
            </p>
            <div
              class="booked"
              v-for="(n, index) in booked[i - 1]"
              :style="{ top: n * 30 + 20 + 'px' }"
              :key="index"
            >
              <!-- <span class="txt">已预约</span> -->
            </div>
            <div
              class="order"
              v-for="(n, index) in newOrder[i - 1]"
              :style="{ top: n * 30 + 20 + 'px' }"
              :key="index"
            >
              <!-- <span class="txt">预约</span> -->
            </div>
            <div
              class="full"
              v-for="(n, index) in full[i - 1]"
              :style="{ top: n * 30 + 20 + 'px' }"
              :key="index"
            >
              <!-- <span class="txt">已满</span> -->
            </div>
          </li>
        </ul>
        <div class="foot">
          <a
            class="ui-btn ligh"
            @click="reset"
          >{{ $t('common.reset') }}</a>
          <a
            class="ui-btn"
            @click="submit"
          >{{ $t('common.comfirm') }}</a>
          <a
            class="ui-btn gray"
            href="javascript: history.go(-1);"
          >{{
            $t('common.back')
          }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import getTimeArr from '@/data.js'
import moment from 'moment'
import {
  getBaseProfile,
  getTeacherAppointedTimeList,
  getScheduleListByTeacherId,
} from '@/service/teacherApi.js'
import { getStudentStudyCourseList } from '@/service/studentApi.js'
import jstz from 'jstz'
export default {
  data() {
    return {
      moment,
      timeArr: [],
      newOrder: [[], [], [], [], [], [], []],
      booked: [[], [], [], [], [], [], []],
      full: [[], [], [], [], [], [], []],
      currentDay: '',
      dateArr: [
        { date: '', show: '', week: this.$t('weeks.mon') },
        { date: '', show: '', week: this.$t('weeks.tues') },
        { date: '', show: '', week: this.$t('weeks.wed') },
        { date: '', show: '', week: this.$t('weeks.thur') },
        { date: '', show: '', week: this.$t('weeks.fri') },
        { date: '', show: '', week: this.$t('weeks.sat') },
        { date: '', show: '', week: this.$t('weeks.sun') },
      ],
      info: '',
    }
  },
  methods: {
    init() {
      this.getBaseProfile()
    },
    async getBaseProfile() {
      let res = await getBaseProfile({ teacherId: this.$route.query.id })
      if (res.data.status === 1) {
        this.info = res.data.data
        if (this.info.hasOwnProperty('courseName')) {
          if (this.info.courseName.split(',').length > 0) {
            this.info.courseName = this.info.courseName
              .split(',')
              .filter((val) => val)
              .join(',')
          }
        }
        this.$nextTick(() => {
          this.$refs.times.scrollTop = 960
        })
      }
    },
    async showOrderList() {
      this.timeArr = getTimeArr(1)
      this.booked = [[], [], [], [], [], [], []]
      this.full = [[], [], [], [], [], [], []]
      const beginTime = moment(this.dateArr[0].date).format('X')
      const endTime = moment(this.dateArr[6].date).add(1, 'days').format('X')
      this.getScheduleListByTeacherId(beginTime, endTime)
      const res = await getTeacherAppointedTimeList({
        teacherId: this.$route.query.id,
        beginTime: beginTime,
        endTime: endTime,
      })
      const res2 = await getStudentStudyCourseList({
        beginTime: beginTime,
        endTime: endTime,
      })
      if (res2.data.status === 1 && res.data.status === 1) {
        this.setDisable(res2.data.data.concat(res.data.data))
      }
    },
    async getScheduleListByTeacherId(beginTime, endTime) {
      const timeZone = jstz.determine().name()
      const res = await getScheduleListByTeacherId({
        teacherId: this.$route.query.id,
        timeIntervalBegin: beginTime,
        timeIntervalEnd: endTime,
        targetTimeZone: timeZone,
      })
      if (res.data.status === 1) {
        if (res.data.data.length) {
          for (let i = 0; i < res.data.data.length; i++) {
            let arr = res.data.data[i].entries
            for (let j = 0; j < arr.length; j++) {
              if (arr[j].scheduleEntryType === 1) {
                let arr2 = arr[j].weekDays.split(',')
                // let start = arr[j].timeBegin / 900
                // let end = arr[j].timeEnd / 900
                let startTime = moment(
                  arr[j].targetBeginTimeName,
                  'HH:mm:ss'
                ).format('HH:mm')
                let endTime = moment(
                  arr[j].targetEndTimeName,
                  'HH:mm:ss'
                ).format('HH:mm')
                for (let k = 0; k < arr2.length; k++) {
                  let x = arr2[k] - 1
                  let start = this.timeArr[x].findIndex(
                    (item) => item.time === startTime
                  )
                  let end = this.timeArr[x].findIndex(
                    (item) => item.time === endTime
                  )
                  for (let l = start; l <= end; l++) {
                    if (
                      moment().isBefore(
                        moment(this.dateArr[x].date).endOf('day')
                      )
                    ) {
                      this.timeArr[x][l].state = 0
                    }
                  }
                }
              }
            }
          }
          for (let i = 0; i < res.data.data.length; i++) {
            let arr = res.data.data[i].entries
            for (let j = 0; j < arr.length; j++) {
              if (arr[j].scheduleEntryType === 2) {
                let x = -1
                for (let k = 0; k < 7; k++) {
                  if (
                    moment(this.dateArr[k].date).isSame(
                      arr[j].scheduleDate * 1000,
                      'day'
                    )
                  ) {
                    x = k
                    break
                  }
                }

                if (x !== -1) {
                  let start = arr[j].timeBegin / 900
                  let end = arr[j].timeEnd / 900
                  for (let l = start; l <= end; l++) {
                    this.timeArr[x][l].state = 1
                  }
                }
              }
            }
          }
          // console.log(this.timeArr);
        }
      }
    },
    setDisable(data) {
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < 7; j++) {
          if (
            moment(data[i].beginTime * 1000).format('YYYYMMDD') ==
            moment(this.dateArr[j].date).format('YYYYMMDD')
          ) {
            let n =
              (moment(data[i].beginTime * 1000).format('X') -
                moment(this.dateArr[j].date).format('X')) /
              900
            if (this.user.uid === data[i].studentId) {
              this.booked[j].push(n)
            } else {
              this.full[j].push(n)
            }
          }
        }
      }
      let arr = this.booked.concat(this.full) // 设置不可预约字段
      for (let i = 0; i < 14; i++) {
        if (arr[i].length) {
          for (let j = 0; j < arr[i].length; j++) {
            let n = arr[i][j]
            let y = i
            if (i >= 7) {
              y = i - 7
            }
            for (let x = 0; x < 5; x++) {
              this.timeArr[y][n + x].state = 2
            }
          }
        }
      }
    },
    order(x, y, row) {
      if (row[y].state === 0 && y < row.length - 4) {
        let state = true
        for (let j = 1; j < 5; j++) {
          if (row[y + j].state !== 0) {
            state = false
          }
        }
        if (state) {
          if (this.newOrder[x].length) {
            for (let i = 0; i < this.newOrder[x].length; i++) {
              if (
                (this.newOrder[x][i] - 5 < y && this.newOrder[x][i] > y) ||
                (this.newOrder[x][i] + 5 > y && this.newOrder[x][i] < y)
              ) {
                this.newOrder[x].splice(i, 1)
                i--
              }
            }
          }
          this.newOrder[x].push(y)
        }
      }
    },
    resetDate() {
      let day = moment(this.currentDay).format('d')
      if (day == 0) {
        day = 7
      }
      for (let i = 0; i < 7; i++) {
        this.dateArr[i].date = moment(this.currentDay)
          .subtract(day - i - 1, 'day')
          .format('YYYY-MM-DD')
        if (
          moment(this.dateArr[i].date).format('YYYYMMDD') ===
          moment().format('YYYYMMDD')
        ) {
          this.dateArr[i].show = this.$t('weeks.today')
        } else {
          this.dateArr[i].show = moment(this.dateArr[i].date).format('DD/MM')
        }
      }
      this.showOrderList()
    },
    preWeek() {
      this.currentDay = moment(this.currentDay)
        .subtract(7, 'day')
        .format('YYYYMMDD')
      this.resetDate()
    },
    nextWeek() {
      this.currentDay = moment(this.currentDay).add(7, 'day').format('YYYYMMDD')
      this.resetDate()
    },
    reset() {
      this.newOrder = [[], [], [], [], [], [], []]
    },
    toDetail() {
      this.$router.push({
        path: '/teachers/teacherDetail',
        query: { id: this.$route.query.id },
      })
    },
    submit() {
      let arr = []
      for (let i = 0; i < 7; i++) {
        if (this.newOrder[i].length) {
          for (let j = 0; j < this.newOrder[i].length; j++) {
            arr.push(
              moment(this.dateArr[i].date)
                .add(this.newOrder[i][j] * 15, 'm')
                .format('x')
            )
          }
        }
      }
      let obj = { teacherId: this.$route.query.id, timeArr: [...new Set(arr)] }
      this.$router.push({
        path: '/order',
        query: { data: JSON.stringify(obj) },
      })
    },
  },
  computed: {
    user() {
      return JSON.parse(this.$store.getters.GETUSER)
    },
  },
  created() {
    this.init()
    this.currentDay = moment().format('YYYYMMDD')
    this.resetDate()
  },
  mounted() {},
}
</script>
<style lang="scss" scoped>
.head {
  padding: 40px 0 50px;
  background: #fff;
  box-shadow: 0 6px 14px rgba($color: #000, $alpha: 0.05);
  position: relative;
  z-index: 1;
  .article {
    padding: 30px;
  }
  .avatar {
    float: left;
    width: 320px;
    height: 320px;
    position: relative;
    font-size: 0;
    margin-right: 50px;
    .img {
      width: 100%;
      height: 100%;
    }
  }
  .tip {
    position: absolute;
    top: -12px;
    right: -15px;
    width: 111px;
    height: 111px;
    background: url(../assets/triangle2.png);
    text-align: center;
    .txt {
      display: inline-block;
      font-size: 21px;
      transform: rotate(45deg);
      color: #fff;
      transform-origin: 0 141%;
    }
  }
  .btns {
    float: right;
    width: 236px;
    padding: 80px 0 0 30px;
    text-align: left;
    margin-top: 33px;
    height: 267px;
    border-left: 1px solid #dcdcdc;
    text-align: center;
    .ui-btn {
      margin-top: 30px;
    }
  }
  .info {
    padding-top: 60px;
    p {
      margin-bottom: 10px;
      font-size: 18px;
      color: #999;
    }
    .name {
      font-size: 48px;
      color: #002147;
      line-height: 64px;
    }
    .lab {
      color: #000;
    }
    .price {
      font-size: 32px;
      color: #ff9b04;
      margin-top: 30px;
    }
  }
  .tag {
    display: inline-block;
    margin: 0 30px 20px 0;
    padding: 0 16px;
    height: 24px;
    line-height: 24px;
    border-radius: 24px;
    background: #a9c4b1;
    color: #fff;
    font-size: 14px;
  }
}
.title-box {
  height: 140px;
  background: #fff;
  .article {
    padding: 50px 93px 0;
  }
  .title {
    font-size: 32px;
    line-height: 42px;
    text-align: center;
  }
}
.pre,
.next {
  height: 42px;
  font-size: 16px;
  color: #666;
  line-height: 42px;
  transition: opacity 0.3s;
  &:hover {
    opacity: 0.7;
  }
  &:active {
    opacity: 0.9;
  }
}
.pre {
  float: left;
  padding-left: 49px;
  background: url(../assets/arrow_left.png) no-repeat left center;
}
.next {
  float: right;
  padding-right: 49px;
  background: url(../assets/arrow_right.png) no-repeat right center;
}
.pannel {
  margin: 30px 0 150px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 6px 12px rgba($color: #000000, $alpha: 0.05);
}
.filter {
  padding: 20px 80px 0;
  border-bottom: 1px solid #d6d6d6;
  line-height: 64px;
  height: 84px;
}
.timezone {
  float: right;
  padding-left: 40px;
  height: 64px;
  line-height: 64px;
  background: url(../assets/time.png) no-repeat left center;
  font-size: 16px;
  color: #666;
}
.dates {
  overflow: hidden;
  height: 95px;
  border-bottom: 1px solid #d6d6d6;
  padding: 16px 75px 0;
  li {
    float: left;
    margin: 0 5px;
    width: 140px;
    text-align: center;
  }
  .week {
    font-size: 24px;
  }
  .date {
    font-size: 16px;
    color: #666;
    margin-top: 5px;
  }
}
.times {
  overflow: hidden;
  padding: 0 37px;
  overflow-y: auto;
  height: 540px;
  display: flex;
  li {
    flex: 1;
    width: 100px;
    margin: 0 4px;
    padding: 20px 0;
    float: left;
    text-align: center;
    color: #666;
    line-height: 30px;
    position: relative;
    min-height: 3470px;
  }
  li:nth-child(2n + 1) {
    background: #ebebeb;
  }
  li:nth-child(2n) {
    background: #8a8a8a;
  }
  p {
    position: relative;
    z-index: 1;
    cursor: pointer;
    transition: color 0.3s;
    height: 30px;
    color: #0000cd;
    &:hover {
      color: #000;
    }
    &.disable {
      cursor: no-drop;
      color: #cecdcd;
    }
    &.fulled {
      cursor: no-drop;
      color: #666;
    }
  }
}
.booked,
.full,
.order {
  position: absolute;
  left: 0;
  top: 80px;
  right: 0;
  height: 150px;
  border-radius: 20px;
  border: 1px solid #002314;
  padding-left: 108px;
  text-align: left;
  .txt {
    display: inline-block;
    width: 18px;
    font-size: 18px;
    line-height: 24px;
    vertical-align: middle;
  }
  &:after {
    content: '';
    height: 100%;
    display: inline-block;
    vertical-align: middle;
  }
}
.booked {
  background: #9dada2;
}
.full {
  background: #cacaca;
}
.order {
  background: #4e9cda;
}
.foot {
  padding: 65px 0 80px;
  text-align: center;
  .ui-btn {
    margin: 0 15px;
  }
}
</style>
